import React from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import Header from '../components/Header';
import { useNotices } from '../contexts/NoticeContext';

const NoticeDetail: React.FC = () => {
  const { id } = useParams<{ id: string }>();
  const navigate = useNavigate();
  const { notices } = useNotices();

  const notice = notices.find(n => n.id === id);

  if (!notice) {
    return (
      <div className="min-h-screen flex flex-col">
        <Header />
        <main className="flex-1 pt-20 bg-gray-50">
          <div className="max-w-4xl mx-auto px-6 py-12">
            <div className="bg-white rounded-lg shadow-sm p-8 text-center">
              <p className="text-gray-500">공지사항을 찾을 수 없습니다.</p>
              <button
                onClick={() => navigate('/notice')}
                className="mt-4 px-6 py-2 bg-blue-600 text-white rounded-lg hover:bg-blue-700"
              >
                목록으로
              </button>
            </div>
          </div>
        </main>
      </div>
    );
  }

  return (
    <div className="min-h-screen flex flex-col">
      <Header />

      <main className="flex-1 pt-20 bg-gray-50">
        <div className="max-w-4xl mx-auto px-6 py-12">
          <div className="bg-white rounded-lg shadow-sm overflow-hidden">
            {/* Header */}
            <div className="border-b border-gray-200 px-8 py-6">
              <h1 className="text-3xl font-bold text-gray-900 mb-4">{notice.title}</h1>
              <div className="flex items-center gap-6 text-sm text-gray-500">
                <span>작성일: {notice.date}</span>
                <span>조회수: {notice.views}</span>
              </div>
            </div>

            {/* Content */}
            <div className="px-8 py-8">
              <div
                className="prose max-w-none"
                dangerouslySetInnerHTML={{ __html: notice.content }}
              />
            </div>

            {/* Footer */}
            <div className="border-t border-gray-200 px-8 py-6 flex justify-end">
              <button
                onClick={() => navigate('/notice')}
                className="px-6 py-2 bg-gray-600 text-white rounded-lg hover:bg-gray-700"
              >
                목록으로
              </button>
            </div>
          </div>
        </div>
      </main>
    </div>
  );
};

export default NoticeDetail;
